/* @flow */
import { Container } from 'flux/utils';
import * as React from 'react';
import ChatStore from 'chat/stores/ChatStore';
import ChatActions from 'chat/actions/ChatActions';
import ChatAddParticipant from 'chat/components/ChatAddParticipant.jsx';
import Chat from 'entities/Chat';

type Props = {
  chatUuid: string,
  onAddParticipants: () => void,
  children: (disabled: boolean) => void,
};

type State = {
  chat: ?Chat,
};

class ChatAddParticipantContainer extends React.Component<Props, State> {
  static getStores() {
    return [ChatStore];
  }

  static calculateState(prevState, props): State {
    return {
      chat: ChatStore.getChat(props.chatUuid),
    };
  }

  componentDidMount() {
    if (!this.state.chat) {
      ChatActions.loadChat(this.props.chatUuid);
    }
  }

  render() {
    if (!this.state.chat) {
      return null;
    }

    return (
      <ChatAddParticipant onAddParticipants={this.props.onAddParticipants} chat={this.state.chat}>
        {this.props.children}
      </ChatAddParticipant>
    );
  }
}

export default Container.create(ChatAddParticipantContainer, { withProps: true });
